import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import SelectBoxViewModel from '@/ViewModels/Controls/SelectBoxViewModel';

export default class EnumerationListBoxViewModel extends ControlViewModel {

    /**
     * Die wählbaren Optionen
     */
    public selectBox: SelectBoxViewModel;

    /**
     * Das ViewModel für die EnumerationListBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.selectBox = this.paramOrDefault(params.selectBox, null);
    }

    public resetValue(): void {
        this.selectBox.value(null);
    }
}

ComponentManager.setViewModel('EnumerationListBoxViewModel', EnumerationListBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');